import React, { useContext, useState } from 'react';
import { Text, View } from 'react-native';
import CdnImage from '../common/CdnImage';
import CdnImageBackground from '../common/CdnImageBackground';
import ComponentContainer from '../common/ComponentContainer';
import { H1, H4 } from '../text';
import { default as AppConstants } from '../../common/Constants';
import LayoutContext from '../../contexts/Layout';

const FullWidthImage = ({ arrowIndicatorTitle, description, image, nodeTypeAlias = 'FullWidthImage', textColor, title, titleLocation, width, hardWidth }) => {
    const { layout } = useContext(LayoutContext);
    const [imageDimensions, setImageDimensions] = useState();

    if (layout.device.isDesktopOrLaptop) {
        if (titleLocation?.equals(AppConstants.TITLE_ABOVE_IMAGE)) {
            return (
                <View style={{ flexDirection: 'row' }} dataSet={{ umbracoComponentName: nodeTypeAlias }}>
                    <View>
                        <View
                            style={{ flexDirection: 'row', marginLeft: layout.styleGuide.spacer1, marginBottom: layout.styleGuide.spacer3 }}
                            dataSet={{
                                spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})`,
                                spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`
                            }}
                        >
                            <View>
                                {!!title && <H1 text={title} />}
                                {!!description && <H4 text={description} />}
                            </View>
                        </View>
                        <View style={{ flexDirection: 'row' }}>
                            <CdnImage uri={`https:${image.cdnImagePath}`} width={hardWidth} />
                        </View>
                        {!!arrowIndicatorTitle && (
                            <View style={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'center' }}>
                                <View style={{ marginTop: 2 }}>
                                    <Text numberOfLines={1} style={{ color: '#000', fontFamily: 'GothamBook', fontSize: 12 }}>
                                        {arrowIndicatorTitle}
                                    </Text>
                                </View>
                            </View>
                        )}
                    </View>
                </View>
            );
        } else {
            return (
                <View
                    style={{ marginBottom: layout.styleGuide.componentSeparator }}
                    dataSet={{ umbracoComponentName: nodeTypeAlias, spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})` }}
                >
                    <CdnImageBackground
                        imageDimensions={imageDimensions}
                        setImageDimensions={setImageDimensions}
                        uri={`https:${image.cdnImagePath}`}
                        width={hardWidth}
                        style={{ width: '100%' }}
                    >
                        <ComponentContainer style={{ backgroundColor: 'transparent', flex: 1, marginBottom: undefined, marginRight: undefined, marginTop: undefined }}>
                            <View style={{ position: 'absolute', top: 10 }}>
                                {titleLocation?.toLowerCase().includes('upper left') && (
                                    <View>
                                        {!!title && <H1 style={{ color: textColor }} text={title} />}
                                        {!!description && description?.length > 0 && <H4 style={{ color: textColor || '#000' }} text={description} />}
                                    </View>
                                )}
                                {titleLocation?.toLowerCase().includes('upper right') && (
                                    <View>
                                        {!!title && <H1 style={{ color: textColor }} text={title} />}
                                        {!!description && description?.length > 0 && <H4 style={{ color: textColor || '#000' }} text={description} />}
                                    </View>
                                )}
                            </View>

                            <View style={{ position: 'absolute', bottom: 10 }}>
                                {titleLocation?.toLowerCase().includes('lower left') && (
                                    <View>
                                        {!!title && <H1 style={{ color: textColor }} text={title} />}
                                        {!!description && description?.length > 0 && <H4 style={{ color: textColor || '#000' }} text={description} />}
                                    </View>
                                )}
                                {titleLocation?.toLowerCase().includes('lower right') && (
                                    <View>
                                        {!!title && <H1 style={{ color: textColor }} text={title} />}
                                        {!!description && description?.length > 0 && <H4 style={{ color: textColor || '#000' }} text={description} />}
                                    </View>
                                )}
                            </View>
                        </ComponentContainer>
                    </CdnImageBackground>
                </View>
            );
        }
    } else {
        return (
            <View dataSet={{ umbracoComponentName: nodeTypeAlias }}>
                <CdnImage uri={`https:${image.cdnImagePath}`} width={hardWidth} style={{ height: '100%' }} />
                <View style={{ backgroundColor: '#dde4e9', flexDirection: 'row' }}>
                    <View
                        style={{ flex: 1, marginVertical: layout.styleGuide.spacer7, marginLeft: layout.styleGuide.spacer1 }}
                        dataSet={{
                            spacerBottom: `StyleGuide.Spacer7(${layout.styleGuide.spacer7})`,
                            spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                            spacerTop: `StyleGuide.Spacer7(${layout.styleGuide.spacer7})`
                        }}
                    >
                        {!!title && <H1 style={{ color: '#000' }} text={title} />}
                        {!!description && description?.length > 0 && <H4 style={{ color: '#000', textWrap: 'wrap' }} text={description} />}
                    </View>
                </View>
                {!!arrowIndicatorTitle && (
                    <View style={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'center' }}>
                        <View style={{ marginTop: 2 }}>
                            <Text numberOfLines={1} style={{ color: '#000', fontFamily: 'GothamBook', fontSize: 12 }}>
                                {arrowIndicatorTitle}
                            </Text>
                        </View>
                    </View>
                )}
            </View>
        );
    }
};

export default FullWidthImage;
